/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiScreeningHitIdentity
 */
export interface ApiScreeningHitIdentity {
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningHitIdentity
     */
    value: string;
    /**
     * 
     * @type {ApiScreeningHitIdentityTypeEnum}
     * @memberof ApiScreeningHitIdentity
     */
    type: ApiScreeningHitIdentityTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiScreeningHitIdentityTypeEnum {
    NAME = 'NAME',
    TITLE = 'TITLE',
    OCCUPATION = 'OCCUPATION',
    AKA = 'AKA'
}


/**
 * Check if a given object implements the ApiScreeningHitIdentity interface.
 */
export function instanceOfApiScreeningHitIdentity(value: object): value is ApiScreeningHitIdentity {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ApiScreeningHitIdentityFromJSON(json: any): ApiScreeningHitIdentity {
    return ApiScreeningHitIdentityFromJSONTyped(json, false);
}

export function ApiScreeningHitIdentityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScreeningHitIdentity {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'type': json['type'],
    };
}

export function ApiScreeningHitIdentityToJSON(json: any): ApiScreeningHitIdentity {
    return ApiScreeningHitIdentityToJSONTyped(json, false);
}

export function ApiScreeningHitIdentityToJSONTyped(value?: ApiScreeningHitIdentity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'type': value['type'],
    };
}

